import { Ticker } from '@pixi/ticker';
import gsap from 'gsap';
export function limitFPS(fps = 60) {
    Ticker.shared.maxFPS = fps;
    Ticker.system.maxFPS = fps;
    gsap.ticker.fps(fps);
}
